// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"K3-z","displaySixCardTiles":"L3-z"};